import Logger from '../utilities/logger';
import A11yConsentApi from '../a11y-consent-api';
import AbstractComponent from '../components/abstract-component';

/**
 * Base for a consent view. A view is considered a component, that shows consent options to the user, e.g. within a
 * modal or a banner or something similar. In any way, such a view requires some input from the user.
 *
 * @author Philipp Seiler <sep@earlybird.at>
 */
export default abstract class AbstractView extends AbstractComponent {
  // Contains all interactable components of the view
  protected readonly document: HTMLElement;

  protected constructor(api: A11yConsentApi, container: HTMLElement) {
    super(api, container);
    Logger.debug('abstract-view', 'Starting to construct.');

    const document = this.container.querySelector<HTMLElement>(':scope > [role="document"]');
    if (!document) {
      throw new Error('Document container missing.');
    }
    this.document = document;

    this.api.emitter.on('acceptAll', () => {
      this.hide();
    });
    this.api.emitter.on('rejectAll', () => {
      this.hide();
    });
    this.api.emitter.on('save', () => {
      this.hide();
    });
    this.api.emitter.on('reset', () => {
      this.show();
    });

    Logger.debug('abstract-view', 'Finished constructing.');
  }

  /**
   * Shows the view.
   */
  public abstract show(): void;

  /**
   * Hides the view.
   */
  public abstract hide(): void;
}
